<template>
  <div>
    <div v-if="data.docSign">
      <div class="login-alert p-3 text-center mb-3">
        <div class="text-primary">Внимание!</div>
        <span
          >Документ успешно принят. После проверки с вами свяжется
          менеджер.</span
        >
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 col-lg-6">
        <Autocomplete
          class="mb-3"
          v-model="data.LastName"
          type="fio"
          label="Фамилия"
          :payload="{ parts: ['SURNAME'] }"
          placeholder="Фамилия"
          :error="errors['LastName']"
          :disabled="true"
          @select="(d) => (data.LastName = d.value)"
        />

        <div class="row">
          <div class="col-md-6">
            <Autocomplete
              class="mb-3"
              v-model="data.FirstName"
              type="fio"
              label="Имя"
              :payload="{ parts: ['NAME'] }"
              placeholder="Имя"
              :error="errors['FirstName']"
              :disabled="true"
              @select="(d) => (data.FirstName = d.value)"
            />
          </div>

          <div class="col-md-6">
            <Autocomplete
              class="mb-3"
              v-model="data.MidName"
              type="fio"
              label="Отчество"
              :payload="{ parts: ['PATRONYMIC'] }"
              placeholder="Отчество"
              :error="errors['MidName']"
              :disabled="true"
              @select="(d) => (data.MidName = d.value)"
            />
          </div>

          <div class="col-md-6">
            <ui-input-box-floating class="mb-3" :error="errors['bdate']">
              <ui-input
                v-model="data.bdate"
                placeholder="Дата рождения"
                type="date"
                :disabled="disabled"
              />
              <ui-input-label>Дата рождения</ui-input-label>
            </ui-input-box-floating>
          </div>

          <div class="col-md-6">
            <ui-input-box-floating class="mb-3" :error="errors['bPlace']">
              <ui-input
                v-model="data.bPlace"
                type="text"
                placeholder="Место рождения"
                :disabled="disabled"
              />
              <ui-input-label>Место рождения</ui-input-label>
            </ui-input-box-floating>
          </div>
        </div>

        <div size="2" class="hr"></div>
        <div class="fw-bold py-2">Паспорт, СНИЛС, ИНН</div>

        <ui-input-box-floating class="mb-3" :error="errors['citizenship']">
          <select
            v-model="data.citizenship"
            class="form-control form-select"
            :disabled="disabled"
          >
            <option
              v-for="(item, index) in citizenshipList"
              :value="item.NbkiNo"
              :key="index"
            >
              {{ item.Name }}
            </option>
          </select>
          <ui-input-label>Гражданство</ui-input-label>
        </ui-input-box-floating>

        <ui-input-box-floating
          v-if="data.citizenship == 643"
          class="mb-3"
          :error="errors['serno']"
        >
          <ui-input
            v-model="data.serno"
            type="text"
            maxlength="11"
            @input="onSernoInput"
            placeholder="Серия и номер паспорта"
            :disabled="disabled"
          />
          <ui-input-label>Серия и номер паспорта</ui-input-label>
        </ui-input-box-floating>

        <ui-input-box-floating v-else class="mb-3" :error="errors['serno']">
          <ui-input
            v-model="data.serno"
            type="text"
            @input="onSernoInput"
            placeholder="Серия и номер паспорта"
            :disabled="disabled"
          />
          <ui-input-label>Серия и номер паспорта</ui-input-label>
        </ui-input-box-floating>

        <div
          v-if="passStatus === false"
          class="login-alert p-3 text-center mb-3 error"
        >
          <div class="text-primary">Ошибка!</div>
          <span v-html="'Данные паспорта не подтверждены'"></span>
        </div>

        <div
          v-else-if="passStatusFNS === false"
          class="login-alert p-3 text-center mb-3"
        >
          <div class="text-primary">Внимание!</div>
          <span
            v-html="
              'Не удалось подтвердить соответствие паспорта и ИНН по данным ФНС'
            "
          ></span>
        </div>

        <ui-input-box-floating class="mb-3" :error="errors['passOrg']">
          <ui-input
            v-model="data.passOrg"
            type="text"
            placeholder="Место выдачи"
            :disabled="disabled"
          />
          <ui-input-label>Место выдачи</ui-input-label>
        </ui-input-box-floating>

        <div class="row">
          <div class="col-md-6">
            <ui-input-box-floating class="mb-3" :error="errors['passDate']">
              <ui-input
                v-model="data.passDate"
                placeholder="Дата выдачи"
                type="date"
                :disabled="disabled"
              />
              <ui-input-label>Дата выдачи</ui-input-label>
            </ui-input-box-floating>
          </div>
          <div class="col-md-6">
            <ui-input-box-floating class="mb-3" :error="errors['passDeptCode']">
              <ui-input
                v-model="data.passDeptCode"
                placeholder="Код подразделения"
                type="text"
                :disabled="disabled"
              />
              <ui-input-label>Код подразделения</ui-input-label>
            </ui-input-box-floating>
          </div>
        </div>

        <ui-input-box-floating class="mb-3" :error="errors['address']">
          <ui-input
            v-model="data.address"
            type="text"
            placeholder="Адрес регистрации (По паспорту)"
            :disabled="disabled"
          />
          <ui-input-label>Адрес регистрации (По паспорту)</ui-input-label>
        </ui-input-box-floating>

        <div
          v-if="addressStatus === false"
          class="login-alert p-3 text-center mb-3"
        >
          <div class="text-primary">Внимание!</div>
          <span v-html="'Адрес не подтверждён ФИАС'"></span>
        </div>

        <div class="row">
          <div class="col-md-6">
            <ui-input-box-floating class="mb-3" :error="errors['inn']">
              <ui-input
                v-model="data.inn"
                placeholder="ИНН"
                type="text"
                :disabled="true"
              />
              <ui-input-label>ИНН</ui-input-label>
            </ui-input-box-floating>
          </div>
          <div class="col-md-6">
            <ui-input-box-floating class="mb-3" :error="errors['snils']">
              <ui-input
                v-model="data.snils"
                placeholder="СНИЛС"
                type="text"
                :disabled="disabled"
              />
              <ui-input-label>СНИЛС</ui-input-label>
            </ui-input-box-floating>
          </div>
        </div>

        <div size="2" class="hr"></div>
        <div class="fw-bold py-2">Контакты</div>

        <div class="row">
          <div class="col-md-6">
            <ui-input-box-floating class="mb-3" :error="errors['telMob']">
              <ui-input
                v-model="data.telMob"
                placeholder="Телефон"
                type="text"
                :disabled="disabled"
              />
              <ui-input-label>Телефон</ui-input-label>
            </ui-input-box-floating>
          </div>
          <div class="col-md-6">
            <ui-input-box-floating class="mb-3" :error="errors['email']">
              <ui-input
                v-model="data.email"
                placeholder="E-mail"
                type="text"
                :disabled="disabled"
              />
              <ui-input-label>E-mail</ui-input-label>
            </ui-input-box-floating>
          </div>
        </div>
      </div>
    </div>

    <div class="page-title">Подпись</div>
    <div size="2" class="hr mb-3"></div>
    <div>
      Продолжая использовать сервис, я соглашаюсь с
      <a href="https://www.stone-xxi.ru/terms-of-use/" target="_blank"
        >Правилами пользования</a
      >
      и
      <a href="https://www.stone-xxi.ru/privacy-policy/" target="_blank"
        >Политикой конфиденциальности и обработки персональных данных</a
      >
    </div>

    <Sign
      :phone="data.telMob"
      :inn="data.inn"
      :getFile="getFile"
      title="STONE-XXI - СОПД"
      :show="['print', 'nopaper', 'podpislon', 'fns']"
      :default="typeSign"
      :uid="props.uid"
      :status="status"
    />

    <div v-if="!(status > 0 && status < 10)">
      <div size="2" class="hr my-3"></div>

      <a href="https://www.stone-xxi.ru/instr_sign_sogl/" target="_blank"
        >Согласие на обработку персональных данных рекомендуется подписать
        цифровой подписью. Инструкция</a
      >
    </div>
  </div>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { postApi, postUrl, formatDate } from "../../../run";

import { useStore } from "vuex";
const store = useStore();

import Autocomplete from "../../../component/Autocomplete/index.vue";

import Sign from "../../../component/sign/index.vue";

import Info from "./info.vue";

import { useRoute } from "vue-router";
const route = useRoute();

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  citizenshipList: {
    type: Array,
    default: () => [],
  },
  uid: {
    type: String,
  },
  status: {
    type: Number,
  },
});

const errors = ref({});

const data = ref({ ...props.data });

const disabled = computed(() => props.status > 0);
const typeSign = computed(() =>
  store.state.main.typeSign ? store.state.main.typeSign : "podpislon"
);

let stopWatch = null;
let saveTimeout = null;

const getFile = async () => {
  errors.value = {};
  return await postApi("/fileSOPD", {
    data: JSON.stringify(data.value),
  }).then((res) => {
    if (res.error) {
      errors.value = res.errors ? res.errors : {};
      return res;
    } else {
      return res.base64File;
    }
  });
};

const isInitialized = ref(false);

const saveDataToServer = () => {
  postApi("/save", {
    data: JSON.stringify(data.value),
    UID: props.uid,
  });
};

const formatSerno = (raw) => {
  if (data.value.citizenship != 643) {
    // Если гражданство не 643, возвращаем строку полностью как есть
    return {
      serno: raw,
      passSer: "",
      passNo: "",
    };
  }

  // Для граждан 643 оставляем только цифры и ограничиваем 10 символами
  let value = raw.replace(/\D/g, "").slice(0, 10);

  // Форматируем с пробелом после первых 4 цифр
  let masked =
    value.length > 4 ? value.slice(0, 4) + " " + value.slice(4) : value;

  return {
    serno: masked,
    passSer: value.slice(0, 4),
    passNo: value.slice(4, 10),
  };
};

const onSernoInput = (e) => {
  const { serno, passSer, passNo } = formatSerno(e.target.value);
  data.value.serno = serno;
  data.value.passSer = passSer;
  data.value.passNo = passNo;
};

// Инициализация при открытии страницы
onMounted(() => {
  data.value.sendLink = data.value?.sendLink
    ? data.value.sendLink
    : data.value.email;
  stopWatch = watch(
    data.value,
    () => {
      if (isInitialized.value) {
        if (saveTimeout) clearTimeout(saveTimeout);
        saveTimeout = setTimeout(() => {
          saveDataToServer();
        }, 1000);
      }
    },
    { deep: true, immediate: true }
  );

  setTimeout(() => {
    isInitialized.value = true;
  }, 1000);

  if (data.value.address) {
    checkAddress(data.value.address);
  }

  const list = props.citizenshipList || [];

  if (data.value.citizenship) {
    const matches = list.filter(
      (item) => item.NbkiNo == data.value.citizenship
    );

    data.value.citizenshipName =
      matches.length > 0 && matches[0]?.Name ? matches[0].Name : false;
  }

  if (!data.value.citizenshipName) {
    data.value.citizenship = 643;
    data.value.citizenshipName = "РОССИЯ";
  }

  if (data.value.serno) {
    const { serno, passSer, passNo } = formatSerno(data.value.serno);
    data.value.serno = serno;
    data.value.passSer = passSer;
    data.value.passNo = passNo;
  }

  checkPass(data.value.address);
  checkPassFNS();
});

onUnmounted(() => {
  if (stopWatch) {
    stopWatch();
  }
});

const addressStatus = ref(null);
let timer = null;

// Функция проверки адреса
const checkAddress = (value) => {
  if (!value) {
    addressStatus.value = null;
    return;
  }

  postUrl("https://lc.stone-xxi.ru/api_v2/api/autocomplete", {
    type: "address",
    query: value,
  })
    .then((res) => {
      let jsonAutocomplete = JSON.parse(res)?.response?.suggestions || [];
      const first = jsonAutocomplete[0]?.data;

      if (first?.fias_id && first?.fias_actuality_state === "0") {
        addressStatus.value = true;
      } else {
        addressStatus.value = false;
      }
    })
    .catch(() => {
      addressStatus.value = false;
    });
};

const passStatus = ref(null);
let timerPass = null;

// Функция проверки адреса
const checkPass = (value) => {
  if (!value || data.value.citizenship != 643) {
    passStatus.value = null;
    return;
  }

  postApi("/passCheck", {
    serno: data.value.serno,
  })
    .then((d) => {
      if (d.status) {
        passStatus.value = true;
      } else {
        passStatus.value = false;
      }
    })
    .catch(() => {
      passStatus.value = false;
    });
};

const passStatusFNS = ref(null);
let timerPassFNS = null;

// Функция проверки адреса
const checkPassFNS = (value) => {
  if (data.value.citizenship != 643) {
    passStatusFNS.value = null;
    return;
  }

  postApi("/passCheckFNS", data.value)
    .then((d) => {
      if (d.status) {
        passStatusFNS.value = true;
      } else {
        passStatusFNS.value = false;
      }
    })
    .catch(() => {
      passStatusFNS.value = false;
    });
};

// Watch за вводом
watch(
  () => data.value.citizenship,
  (newValue) => {
    checkPass(newValue);

    const list = props.citizenshipList || [];

    if (newValue) {
      const matches = list.filter((item) => item.NbkiNo == newValue);

      data.value.citizenshipName =
        matches.length > 0 && matches[0]?.Name ? matches[0].Name : false;
    }

    if (!data.value.citizenshipName) {
      data.value.citizenship = 643;
      data.value.citizenshipName = "РОССИЯ";
    }

    const { serno, passSer, passNo } = formatSerno(data.value.serno);
    data.value.serno = serno;
    data.value.passSer = passSer;
    data.value.passNo = passNo;
  }
);

watch(
  [
    () => data.value.LastName,
    () => data.value.FirstName,
    () => data.value.MidName,
    () => data.value.bdate,
    () => data.value.passSer,
    () => data.value.passNo,
    () => data.value.passDate,
  ],
  (newValue) => {
    passStatusFNS.value = null;
    if (timerPassFNS) clearTimeout(timerPassFNS);
    timerPassFNS = setTimeout(() => {
      checkPassFNS();
    }, 500);
  }
);

// Watch за вводом
watch(
  () => data.value.serno,
  (newValue) => {
    passStatus.value = null;
    if (timerPass) clearTimeout(timerPass);
    timerPass = setTimeout(() => {
      checkPass(newValue);
    }, 500);
  }
);

// Watch за вводом
watch(
  () => data.value.address,
  (newValue) => {
    addressStatus.value = null;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      checkAddress(newValue);
    }, 500);
  }
);

watch(
  () => data.value.serno,
  (newVal) => {
    if (newVal) {
      const { serno, passSer, passNo } = formatSerno(newVal);
      data.value.serno = serno;
      data.value.passSer = passSer;
      data.value.passNo = passNo;
    }
  },
  { immediate: true }
);
</script>